import { render } from "./SelectCard.vue?vue&type=template&id=5b2b5b3e&ts=true"
import script from "./SelectCard.vue?vue&type=script&lang=ts"
export * from "./SelectCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__